import React from 'react'

const IconBackArrow: React.FunctionComponent = () => {
  return (
    <>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 33">
        <path d="M20.879 3.776A63.221 63.221 0 0 0 3.398 17.144c-.244.304-.789 1.212-.69 1.561 1.867 2.442 4.837 2.782 7.355 4.192 2.519 1.41 4.54 4.563 7.669 5.8a3.718 3.718 0 0 0 3.317-.936c.437-.123 1.95-1.775.892-2.184-3.01-1.318-4.615-4.164-7.407-5.874-2.791-1.71-5.383-1.544-7.101-3.792l-.647 1.55A52.247 52.247 0 0 1 20.795 6.485c.83-.234 2.558-1.288 2.481-2.397-.077-1.109-1.83-.473-2.397-.313Z" fill="#111" /><path d="M4.414 18.742a35.739 35.739 0 0 1 30.566 2.78c1.877 1.307 6.012-2.074 4.092-3.37-9.71-6.685-22.786-6.435-33.637-3.138a4.173 4.173 0 0 0-3.085 2.425c-.24 1.152.973 1.61 1.933 1.34" fill="#111" />
      </svg>
    </>
  )
}

export default IconBackArrow
